<template>
  <section class="app-ecommerce-details">
    <b-overlay :show="isLoading || impostoLoading" rounded="sm">
      <template #overlay>
        <div v-if="impostoLoading" class="text-center">
          <strong>Calculando impostos...</strong>
          <b-spinner small class="ml-1"></b-spinner>
        </div>
      </template>
      <b-alert variant="danger" :show="product === undefined">
        <h4 class="alert-heading">Error fetching product data</h4>
        <div class="alert-body">
          No item found with this item slug. Check
          <b-link class="alert-link" :to="{ name: 'apps-e-commerce-shop' }">Shop</b-link> for other items.
        </div>
      </b-alert>
      <b-row class="pb-2 d-flex justify-content-end mr-1" v-if="!isModal">
        <b-col cols="auto" class="text-right align-self-end">
          <p><strong>Total de Pedidos :</strong> {{ totalUnidades }}</p>
          <p><strong>Total Valor : </strong> R$ {{ totalValorFinal.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</p>
        </b-col>
      </b-row>
      <b-row class="my-2" v-if="product">
        <b-col :cols="isModal ? 2 : 1" class="imagens-container pr-0 mt-1">
          <div class="imagens-item">
            <div v-if="product.imagens.length > 0" v-for="(img, index) in product.imagens.slice(0, 5)" :key="index">
              <div class="rounded imagens-item-img" :class="{'selected-img': product.item_img_princial === img.caminho}" :style="isModal ? { width: '40px', height: '40px' } : {}">
                <b-img
                  :src="img.caminho ? img.caminho : imagemPadrao"
                  :alt="`${product.item_name}-${product.item_id}`" class="img-fluid"
                  @click="product.item_img_princial = img.caminho"
                  @mouseover="product.item_img_princial = img.caminho" />
              </div>
            </div>
            <div v-if="product.imagens.length > 5"
              class="d-flex justify-content-center align-items-center bg-grey-1 rounded"
              :style="{ border: '1px solid var(--primary)', width: isModal ? '40px' : '50px', height: isModal ? '40px' : '50px' }" @click="openModal(6)">
              +{{ product.imagens.length - 5 }}
            </div>
          </div>
        </b-col>
        <b-col cols="12" sm="12" :md="isModal ? 4 : 4" class="px-auto mt-1">
          <b-img
            :src="product.item_img_princial ? product.item_img_princial : imagemPadrao"
            :alt="`${product.item_name}-${product.item_id}`"
            :style="[isModal ? { maxHeight: '300px', width: 'auto', margin: '0 auto', display: 'block' } : { minHeight: '350px', padding: '0' }]"
            class="img-fluid" />
        </b-col>

        <b-col cols="12" :md="isModal ? 6 : 7">
          <h4 :class="{'font-medium-3': isModal}">{{ product.referencia }} - {{ product.item_name }}</h4>
          <b-card-text class="item-company mb-0">
            <span>by </span>
            <b-link class="company-name">{{ product.item_marca }}</b-link>
          </b-card-text>
          <div class="ecommerce-details-item_price d-flex flex-wrap mt-1">
            <h4 class="item-item_price mr-1 text-primary">R$ {{ (product.item_price_exibicao.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || product.item_price.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })) }}</h4>
          </div>
          <b-card-text v-if="json[0].embalagens.length !== 0 && !isModal">Disponível - <span class="text-success">Em
              estoque</span></b-card-text>
          <!--        <b-card-text>{{ product.item_caracteristicas }}</b-card-text>-->
          <div v-if="json[0].embalagens.length === 0">

            <b-alert show variant="danger">
              Não há embalagens disponíveis
            </b-alert>
          </div>

          <div class="product-color-options" v-if="json[0].embalagens.length !== 0">
            <h6 :class="{'font-small-3': isModal}">EMBALAGEM</h6>
            <ul class="list-unstyled mb-0 scrollable-pills" style="display: flex; gap: 10px; flex-wrap: wrap;">
              <li v-for="embalagem in json[0].embalagens" :key="embalagem.descricao_embalagem">
                <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  :variant="formColor.embalagem === embalagem.descricao_embalagem ? 'primary' : 'outline-secondary'"
                  :size="isModal ? 'sm' : 'sm'" @click="selectEmbalagem(embalagem)">
                  {{ embalagem.descricao_embalagem }}
                </b-button>
              </li>
            </ul>

            <hr class="my-1">

            <!-- Colors -->
            <div class="product-color-options">
              <h6 :class="{'font-small-3': isModal}">COR</h6>
              <ul class="list-unstyled mb-0 scrollable-pills" style="display: flex; gap: 10px; flex-wrap: wrap;">
                <li v-for="color in availableColors" :key="color.cdnCor">
                  <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    :variant="formColor.color === color.desCor ? 'primary' : 'outline-secondary'" size="sm"
                    @click="selectColor(color)">
                    {{ color.desCor }}
                  </b-button>
                </li>
              </ul>
            </div>
            <!-- Sizes -->
            <hr class="my-1">
            <div class="product-color-options">
              <h6 :class="{'font-small-3': isModal}">TAMANHO</h6>
              <ul class="list-unstyled mb-0 scrollable-pills" style="display: flex; gap: 10px; flex-wrap: wrap;">
                <li v-for="size in availableSizes" :key="size">
                  <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    :variant="formColor.tamanho === size ? 'primary' : 'outline-secondary'" size="sm"
                    @click="formColor.tamanho = size">
                    {{ sizeLabel(size) }}
                  </b-button>
                </li>
              </ul>
            </div>

            <!-- Quantity -->
            <hr class="my-1">
            <div class="product-color-options">
              <h6 :class="{'font-small-3': isModal}">QUANTIDADE</h6>
              <b-form-group>
                <b-input-group style="max-width: 200px;">
                  <b-form-input v-model="formColor.quantidade" type="number" min="1" />
                  <b-input-group-append>
                    <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="primary" @click="repeateAgain">
                      <feather-icon icon="PlusIcon" size="14" />
                      Adicionar
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
                <div v-if="impostoCalculado" class="mt-1">
                  <p class="mb-0 font-small-3">Unitário com Imposto: <strong>R$ {{ impostoCalculado.precoComImposto.toFixed(2) }}</strong></p>
                </div>
              </b-form-group>
            </div>

            <!-- Selected Items -->
            <hr class="my-1" v-if="!isModal"> <!-- Hide if modal because handled by parent or different UI -->
            <div class="mx-1" v-if="!isModal">
              <div>
                <h3>Itens Adicionados</h3>
              </div>
              <div class="row mt-3" style="gap: 10px">

                <div class="col-auto cursor-pointer px-0" v-for="(item, index) in items" :id="item.item_id"
                  :key="item.item_id">
                  <b-badge variant="primary" class="d-flex align-items-center">
                    <span>{{ item.embalagem }} - {{ item.valor }} - {{ item.des_cor }} - {{ item.tamanho }}</span>
                    <button type="button" class="close ml-2" @click="removeItem(index, item)">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </b-badge>
                </div>

              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-overlay>

    <b-modal id="modal-gallery-imagens" hide-footer hide-header
      style="height: 500px; width: 100%;background: transparent; border: none; padding: 0; margin: 0;"
      body-bg-variant="transparent" @shown="initSwiper">
      <swiper ref="refSwiperGallery" class="swiper-gallery gallery-top" :options="swiperOptions"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'">
        <swiper-slide v-for="(data, index) in product.imagens" :key="index">
          <b-img :src="data.caminho" fluid />
        </swiper-slide>

        <div slot="button-next" class="swiper-button-next swiper-button-white" />
        <div slot="button-prev" class="swiper-button-prev swiper-button-white" />
      </swiper>
    </b-modal>
  </section>
</template>

<script>
import {
  BCard, BCardBody, BRow, BCol, BImg, BCardText, BLink, BButton, BDropdown, BDropdownItem, BAlert, BFormGroup, BFormSpinbutton, BBadge, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue';
import Ripple from 'vue-ripple-directive';
import { ref } from '@vue/composition-api';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import axios from 'axios';
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import { getTotvsBaseUrl } from '@/utils/totvsApi';
import { IMAGEM_PADRAO } from '@/utils/imagemUrl';
import { carregarTamanhos, descricaoTamanhoGrade } from '@/utils/tamanhos';

export default {
  directives: {
    Ripple,
  },
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BImg,
    BCardText,
    BLink,
    BButton,
    BDropdown,
    BDropdownItem,
    BAlert,
    BFormGroup,
    BFormSpinbutton,
    BBadge,
    BInputGroup,
    BInputGroupAppend,
    Swiper,
    SwiperSlide,
  },
  props: {
    json: {
      type: Array,
      required: true,
    },
    product: {
      type: Object,
      required: true,
      default: () => ({
        item_id: 1,
        item_name: '0717 - Cueca Boxer Plus',
        slug: 'vic-tsing-wireless-mouse-1',
        item_caracteristicas: 'Cueca Zorba Boxer Plus. Algodão com Elastano. Elástico aparente personalizado. Bojo Forrado. Possui a tecnologia Go Tagless, sem etiquetas costuradas, não arranha e não irrita a pele. Veste do P ao GG.',
        item_marca: 'Hanes',
        item_price: 28.19,
        item_img_princial: 'https://dkpsales-novo-hanes.s3.amazonaws.com/imagens/ImagensB2B/Zorba/717/717_still_1_branco_frente.jpg',
        hasFreeShipping: true,
        rating: 3,
        imagens: [
          // ... Imagens aqui ...
        ],
      }),
    },
    isModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      imagemPadrao: IMAGEM_PADRAO,
      formColor: {
        embalagem: '',
        cdn_embalagem: '',
        color: '',
        tamanho: '',
        quantidade: 0,
      },
      items: [],
      availableColors: [],
      availableSizes: [],
      tamanhosMap: {},
      gradeColorSelecionada: null,
      isLoading: true,
      impostoLoading: false,
      impostoCalculado: null,
      itemMultiplo: false,
      precoPreSimuladoCarregado: false,
      precoBaseUnitario: null,
      swiperOptions: {
        loop: true,
        loopedSlides: 5,
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    };
  },

  watch: {
    json: {
      handler(newJson) {
        console.log('JSON VINDO DO TOTUVS watch', newJson);
      },
      deep: true,
    },
    // formColor: {
    //   deep: true,
    //   handler(newVal) {
    //     if (newVal.color) {
    //       const selectedColor = this.availableColors.find(color => color.desCor === newVal.color)
    //       if (selectedColor) {
    //         this.availableSizes = this.getAvailableSizes(selectedColor)
    //       }
    //     }
    //   }
    // }
  },
  computed: {
    // getInfoItem: {
    //   get() {
    //     return this.$store.getters['intensPedido/getFormData']
    //   },
    //   set(value) {
    //     this.$store.commit('intensPedido/SET_DETALHES_ITEM', value)
    //   }
    // },
    ...mapGetters('InfoPedido', [
      'GET_CLIENTE_DATA',
      'GET_ENDERECO_ENTREGA',
      'GET_DATA_CAPA_PEDIDO',
    ]),
    totalValor() {
      return this.items.reduce((sum, item) => sum + (parseFloat(this.product.item_price) * item.valor), 0);
    },
    totalValorFinal() {
      return this.items.reduce((sum, item) => sum + (parseFloat(this.impostoCalculado.precoComImposto) * item.valor), 0);
    },
    totalUnidades() {
      return this.items.length;
    },

  },
  created() {
    // Verifica se tem os dados necessários
    const formData = this.$store.getters['InfoPedido/GET_VALIDATION_FORM_INFO_PEDIDO'];
    if (!formData) {
      this.$bvModal.hide('modal-top-selected-embalagens');
      this.$bvModal.show('modal-center-info-pedido');
    }
  },
  mounted() {
    carregarTamanhos().then((tamanhos) => { this.tamanhosMap = tamanhos; });
    this.isLoading = false;

    this.$root.$on('info-pedido:updated', this.atualizarDadosPedido);
    this.preSimularImpostoPrimeiroSku();
  },
  methods: {
    async preSimularImpostoPrimeiroSku() {
      try {
        if (this.precoPreSimuladoCarregado) return;
        if (!this.json || !this.json.length || !this.json[0].embalagens || !this.json[0].embalagens.length) return;
        const clienteData = this.GET_CLIENTE_DATA;
        const enderecoEntrega = this.GET_ENDERECO_ENTREGA;
        const dataCapa = this.GET_DATA_CAPA_PEDIDO;
        if (!clienteData || !enderecoEntrega || !dataCapa) return;
        const skuKeys = ['itemExtrapq', 'itemPequeno', 'itemMedio', 'itemGrande', 'itemExtraGd', 'itemSuperGd', 'itemUltraGd', 'itemUnico', 'itemOutros'];
        let firstSkuId = null;
        for (const emb of this.json[0].embalagens) {
          const rows = emb?.grade?.dsHBIgrade?.ttHBIgrade;
          if (Array.isArray(rows)) {
            for (const row of rows) {
              for (const key of skuKeys) {
                const v = row?.[key];
                if (v) { firstSkuId = v; break; }
              }
              if (firstSkuId) break;
            }
          }
          if (firstSkuId) break;
        }
        if (!firstSkuId) return;
        if (this.product && this.product.item_price && this.product.item_price_base === undefined) {
          this.$set(this.product, 'item_price_base', parseFloat(this.product.item_price));
        }
        const precoBase = this.product.item_price_base || parseFloat(this.product.item_price) || 0;
        this.precoBaseUnitario = precoBase;
        const baseUrl = await getTotvsBaseUrl();
        const url = `${baseUrl}/simular-Impostos-novo-metodo`;
        const payload = {
          ttCabPedido: [{
            'c-pr-cod-estabel': dataCapa.estabelecimentoid, 'c-pr-nome-abrev': clienteData.cliente.clientenomeabreviado, 'c-pr-nat-operacao': dataCapa.naturezaoperacaoid || '6101', 'c-pr-cod-canal-venda': clienteData.canalVenda?.canal_venda_id || '', 'c-pr-it-codigo': firstSkuId, 'd-pr-quantidade': 1, 'd-pr-vl-preori-ped': precoBase, 'd-pr-per-des-item': 0.0, 'p-simulacao': 0, 'p-uf-ds': enderecoEntrega.ufid, 'p-cidade-ds': enderecoEntrega.clienteenderecocidade, 'p-contr-icms': dataCapa.clienteisentoie ? 1 : 0, 'p-tp-frete': 0, 'p-tp-tabpre': dataCapa.tabelaprecoid, 'p-cod-cond-pagto': Number(dataCapa.condicaopagamentoid || 0), ttitempedido: [{ itCodigo: firstSkuId }],
          }],
        };
        const resp = await axios.post(url, payload, { headers: { 'Content-Type': 'application/json' } });
        const precoComImposto = resp?.data?.ttRetornoImposto?.[0]?.['d-pr-unitario'];
        if (precoComImposto != null) {
          this.$set(this.product, 'item_price', parseFloat(precoComImposto).toFixed(2));
          this.$set(this.product, 'item_price_exibicao', parseFloat(precoComImposto));
        } else {
          this.$set(this.product, 'item_price_exibicao', precoBase);
        }
        this.precoPreSimuladoCarregado = true;
      } catch (e) {
        console.error('Falha pré-simulação imposto (carrinho):', e);
      }
    },
    atualizarDadosPedido(formData) {
      console.log('Atualizando dados do pedido no componente de detalhes');

      if (this.items && this.items.length > 0) {
        Swal.fire({
          title: 'Dados de pedido alterados',
          text: 'Deseja recalcular os impostos para os itens no carrinho?',
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'Sim, recalcular',
          cancelButtonText: 'Não',
        }).then((result) => {
          if (result.isConfirmed) {
            this.recalcularTodosImpostos();
          }
        });
      }
    },

    async recalcularTodosImpostos() {
      for (const item of this.items) {
        const impostos = await this.calcularImposto({
          item_id: item.item_id,
          valor: item.valor,
        });

        if (impostos) {
          item.precoComImposto = impostos.precoComImposto;
          item.baseIcms = impostos.baseIcms;
          item.valorIcms = impostos.valorIcms;
          item.naturezaoperacaoidimposto = impostos.naturezaoperacaoidimposto;
        }
      }

      this.$forceUpdate();
    },
    initSwiper() {
      this.$nextTick(() => {
        if (this.$refs.refSwiperGallery && this.$refs.refSwiperGallery.$swiper) {
          this.$refs.refSwiperGallery.$swiper.update();
          this.$refs.refSwiperGallery.$swiper.navigation.update();
        }
      });
    },
    openModal(startIndex) {
      this.$bvModal.show('modal-gallery-imagens');
    },
    removeItem(index, item) {
      this.items.splice(index, 1);
      this.$emit('remove-item', item);
    },
    sizeLabel(size) {
      return descricaoTamanhoGrade(this.gradeColorSelecionada, size, this.tamanhosMap);
    },
    getAvailableSizes(color) {
      const sizes = [];
      if (color.itemExtrapq) sizes.push('Extrapq');
      if (color.itemPequeno) sizes.push('Pequeno');
      if (color.itemMedio) sizes.push('Medio');
      if (color.itemGrande) sizes.push('Grande');
      if (color.itemExtraGd) sizes.push('ExtraGd');
      if (color.itemSuperGd) sizes.push('SuperGd');
      if (color.itemUltraGd) sizes.push('UltraGd');
      if (color.itemUnico) sizes.push('Unico');
      if (color.itemOutros) sizes.push('Outros');
      return sizes;
    },
    selectEmbalagem(embalagem) {
      this.formColor.embalagem = embalagem.descricao_embalagem;
      this.formColor.cdn_embalagem = embalagem.cdn_embalagem;

      if (embalagem.grade?.dsHBIgrade?.ttHBIgrade) {
        this.availableColors = embalagem.grade.dsHBIgrade.ttHBIgrade.map((item) => ({
          cdnCor: item.cdnCor,
          desCor: item.desCor,
          itemExtrapq: item.itemExtrapq,
          itemPequeno: item.itemPequeno,
          itemMedio: item.itemMedio,
          itemGrande: item.itemGrande,
          itemExtraGd: item.itemExtraGd,
          itemSuperGd: item.itemSuperGd,
          itemUltraGd: item.itemUltraGd,
          itemUnico: item.itemUnico,
          itemOutros: item.itemOutros,
        }));

        this.availableSizes = [];
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Falha',
            text: 'Cores não encontradas para esta embalagem',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
      }
    },
    selectColor(color) {
      const selectedEmbalagem = this.json[0].embalagens.find((e) => e.descricao_embalagem === this.formColor.embalagem);
      const gradeColor = selectedEmbalagem.grade.dsHBIgrade.ttHBIgrade.find((item) => item.cdnCor === color.cdnCor);

      if (gradeColor) {
        this.formColor.color = gradeColor.desCor;
        this.formColor.tamanho = '';
        this.formColor.quantidade = 0;
        this.gradeColorSelecionada = gradeColor;
        this.availableSizes = this.getAvailableSizes(gradeColor);
      }
    },
    async calcularImposto(newItem) {
      try {
        let clienteData = this.GET_CLIENTE_DATA;
        let enderecoEntrega = this.GET_ENDERECO_ENTREGA;
        let dataCapa = this.GET_DATA_CAPA_PEDIDO;

        if (!clienteData || !clienteData.estabelecimento) {
          const userId = this.getUserId();
          const savedFormData = localStorage.getItem(`infoPedidoForm_${userId}`);

          if (savedFormData) {
            const parsedData = JSON.parse(savedFormData);

            this.$store.commit('InfoPedido/SET_FORM_INFO_PEDIDO', parsedData);

            clienteData = parsedData;
            enderecoEntrega = parsedData.enderecoEntrega;
            dataCapa = {
              estabelecimentoid: parsedData.estabelecimento.estabelecimentoid,
              clientenomeabreviado: parsedData.cliente.clientenomeabreviado,
              naturezaoperacaoid: parsedData.naturezaOperacao?.naturezaoperacaoid || '6101',
              canal_venda_id: parsedData.canalVenda?.canal_venda_id || '',
              clienteisentoie: parsedData.cliente.clienteisentoie,
              tabelaprecoid: parsedData.tabelaPreco.tabelapreco_id,
              condicaopagamentoid: parsedData.condicaoPagamento.condicaopagamentoid,
            };

            this.$store.commit('InfoPedido/SET_CLIENTE_DATA', {
              clienteData: parsedData,
              enderecoEntrega: parsedData.enderecoEntrega,
              dataCapaPedido: dataCapa,
            });
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Erro',
                text: 'Dados do cliente não encontrados. Por favor, selecione o cliente novamente.',
                icon: 'AlertCircleIcon',
                variant: 'danger',
              },
            });
            return null;
          }
        }

        console.log('Cliente Data:', clienteData);

        const baseUrl = await getTotvsBaseUrl();
        const url = `${baseUrl}/simular-Impostos-novo-metodo`;
        const data = {
          ttCabPedido: [{
            'c-pr-cod-estabel': clienteData.estabelecimento.estabelecimentoid,
            'c-pr-nome-abrev': clienteData.cliente.clientenomeabreviado,
            'c-pr-nat-operacao': clienteData.naturezaOperacao?.naturezaoperacaoid || '6101',
            'c-pr-cod-canal-venda': clienteData.canalVenda?.canal_venda_id || '',
            'c-pr-it-codigo': newItem.item_id,
            'd-pr-quantidade': newItem.valor,
            'd-pr-vl-preori-ped': this.product.item_price,
            'd-pr-per-des-item': 0.0000,
            'p-simulacao': 0,
            'p-uf-ds': enderecoEntrega.ufid,
            'p-cidade-ds': enderecoEntrega.clienteenderecocidade,
            'p-contr-icms': dataCapa.clienteisentoie ? 1 : 0,
            'p-tp-frete': 0,
            'p-tp-tabpre': dataCapa.tabelaprecoid,
            'p-cod-cond-pagto': Number(dataCapa.condicaopagamentoid),
            ttitempedido: [{
              itCodigo: newItem.item_id,
            }],
          }],
        };

        this.impostoLoading = true;
        const response = await axios.post(url, data, {
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (response.data.ttRetornoImposto && response.data.ttRetornoImposto[0]) {
          const precoImposto = response.data.ttRetornoImposto[0]['d-pr-unitario'] || 0;
          const valorBaseIcms = response.data.ttRetornoImposto[0]['d-pr-base-icms'] || 0;
          const valorIcms = response.data.ttRetornoImposto[0]['d-pr-valor-icms'] || 0;
          const naturezaoperacaoidimposto = response.data.ttRetornoImposto[0]['c-pr-nat-operacao'] || 0;

          return {
            precoComImposto: precoImposto,
            baseIcms: valorBaseIcms,
            valorIcms,
            naturezaoperacaoidimposto,
          };
        }

        return null;
      } catch (error) {
        console.error('Erro ao fazer a chamada à API:', error);
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Erro ao calcular impostos',
          timer: 2000,
        });
        return null;
      } finally {
        this.impostoLoading = false;
      }
    },
    getUserId() {
      try {
        const userData = JSON.parse(localStorage.getItem('userData'));
        return userData?.id || 'default';
      } catch (error) {
        console.error('Erro ao obter ID do usuário:', error);
        return 'default';
      }
    },
    async repeateAgain() {
      if (!this.formColor.embalagem || !this.formColor.color || !this.formColor.tamanho || !this.formColor.quantidade) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Falha',
            text: 'Obrigatorio Selecionar: Embalagem, Cor, Tamanho e Quantidade.',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
        return;
      }

      const embalagem = this.json[0].embalagens.find((item) => item.descricao_embalagem === this.formColor.embalagem);

      if (embalagem.itemMultiplo !== 0) {
        this.itemMultiplo = true;
        const quantidade = parseInt(this.formColor.quantidade);
        if (quantidade % embalagem.itemMultiplo !== 0) {
          Swal.fire({
            icon: 'warning',
            title: 'Atenção!',
            text: `A quantidade deste item deve ser um múltiplo de ${embalagem.itemMultiplo}!`,
          });
          return;
        }
      }

      const color = embalagem.grade.dsHBIgrade.ttHBIgrade.find((item) => item.desCor === this.formColor.color);

      if (!color) {
        console.error('Color not found in grade');
        return;
      }

      const itemId = color[`item${this.formColor.tamanho}`];

      if (!itemId) {
        console.error('Item ID not found for selected size');
        return;
      }

      const hasDuplicate = this.items.some((item) => item.item_id === itemId
        && item.embalagem === this.formColor.embalagem
        && item.des_cor === this.formColor.color
        && item.tamanho === this.formColor.tamanho);

      if (hasDuplicate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Item Duplicado',
            text: 'O item já foi adicionado. Para alterar a quantidade, dirija-se ao carrinho.',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
        return;
      }

      const impostos = await this.calcularImposto({
        item_id: itemId,
        precoUnitario: (this.product.item_price_base ?? this.product.item_price),
        valor: this.formColor.quantidade,
      });

      if (impostos === null) {
        return;
      }

      const { precoComImposto } = impostos;
      const { baseIcms } = impostos;
      const { valorIcms } = impostos;
      const { naturezaoperacaoidimposto } = impostos;

      const newItem = {
        embalagem: this.formColor.embalagem,
        cdn_embalagem: this.formColor.cdn_embalagem,
        des_cor: this.formColor.color,
        cdn_cor: color.cdnCor,
        tamanho: this.formColor.tamanho,
        item_id: itemId,
        valor: parseInt(this.formColor.quantidade),
        precoComImposto,
        baseIcms,
        valorIcms,
        naturezaoperacaoidimposto,
        itemMultiplo: this.itemMultiplo,
      };

      this.impostoCalculado = impostos;

      this.items.push(newItem);
      this.$emit('update:grade', this.items);
      // this.$emit('calcular-imposto', newItem)
      this.formColor.quantidade = 0;
    },

  },
  beforeDestroy() {
    this.$root.$off('info-pedido:updated', this.atualizarDadosPedido);
  },
};
</script>
<style lang="scss">
@import "~@core/scss/base/pages/app-ecommerce-details.scss";

.destaque {
  border: 1px solid red;
}

// .imagens-container {}

.imagens-item-img {
  border: 1px solid var(--primary);
  width: 50px;
  height: 50px;
}

.imagens-item-img img {
  height: 50px;
}

.imagens-item {
  display: flex;
  flex-direction: column;
  gap: 10px;
  cursor: pointer;
}

@media screen and (max-width: 768px) {
  .imagens-container {
    width: 100%;
    padding-bottom: 10px;
  }

  .imagens-item {
    flex-direction: row;
  }

  // .imagens-item-img img {
  //   width: 100px;
  //   height: 100px;
  // }
}

/* Estilize a modal e o swiper conforme necessário */
.swiper-container {
  width: 100%;
  height: 100%;
}

.swiper-slide img {
  width: 100%;
  height: 100%;
}

/* Horizontal scroll for pills on mobile */
.scrollable-pills {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 6px;
  scroll-snap-type: x proximity;
}
.scrollable-pills li {
  flex: 0 0 auto;
  scroll-snap-align: start;
}
.scrollable-pills::-webkit-scrollbar {
  height: 6px;
}
.scrollable-pills::-webkit-scrollbar-thumb {
  background-color: rgba(0,0,0,0.2);
  border-radius: 3px;
}

@media screen and (max-width: 768px) {
  .scrollable-pills {
    flex-wrap: nowrap;
    max-width: 100%;
  }
}
</style>
